module.exports = __webpack_public_path__ + "img/IMG_2368_L.d1fabe53.webp";